export const EmploymentStatus = [
  'Employed',
  'Self_Employed',
  'Unemployed',
  'Retired',
  'Homemaker',
  'Student',
  'Student_Employed',
  'Volunteer_Worker',

  // Prepop
  'Employed',
  'Self employed',
  'Unemployed/Not Employed',
  'Retired',
  'Homemaker',
  'Student',
  'Student/Employed',
  'Volunteer worker'
];
